// Facebook posts users can share for the DAILY contest "share" bonus (one claim per Bangladesh day).
// Add posts here — the "Claim points → Share" card lists them with a Share-on-Facebook button.
//
//   { id: 'post-1', title: 'English title', titleBn: 'বাংলা শিরোনাম', url: 'https://www.facebook.com/<page>/posts/<id>' }
//
// While the list is empty the card falls back to sharing the user's own referral link.
export const CONTEST_SHARE_POSTS = [];

// Every contest share must carry this hashtag — the contest team checks for it before awarding the points.
// Shown on the share task and pre-filled into the Facebook share dialog.
export const SHARE_HASHTAG = '#sohozkaj';
